export const PHONE_FIELD_DEFAULT_COUNTRY = 'us';

// intlTelInputUtils.validationError codes that mean "wrong digit count for the selected country".
export const PHONE_VALIDATION_ERROR_CODE = {
  TOO_SHORT:      2,
  TOO_LONG:       3,
  INVALID_LENGTH: 5,
} as const;

export const PHONE_FIELD_ERROR = {
  LENGTH: 'fhPhoneLength',
} as const;

export const PHONE_FIELD_MESSAGE: Record<string, string> = {
  [PHONE_FIELD_ERROR.LENGTH]: 'The number of characters doesn\'t match the selected country.',
};
